import { useState, useEffect } from 'react';

import Aside from './Aside';
import Footer from './Footer';
import Section from './Section';

import AOS from "aos";
import "aos/dist/aos.css";

import { Row } from 'react-bootstrap';

export default function Cv(){
    const [loaded, setLoaded] = useState(false)
    
    useEffect(() => {
        if(loaded){
            AOS.init({
                once: true,
            });
            AOS.refresh();
        }

    }, [loaded])

    return(<>
        <main className={`row ${ !loaded && 'd-none'}`}>
            <Aside setLoaded={setLoaded} />
            <Section />
        </main>
        <Footer loaded={loaded}/>
        { !loaded && 
            <Row className='spinner-row'>
                <div className="spinner-grow"
                    role="status">
                        <span className="visually-hidden">Loading...</span>
                </div>
            </Row>
        }
    </>)
}